import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadConfig = useCallback(async () => {
    try {
      const { data } = await api.get("/config");
      setConfig(data);
    } catch (e) {
      setConfig({ google_configured: false });
    }
  }, []);

  const bootstrap = useCallback(async () => {
    await loadConfig();
    const token = localStorage.getItem("shb_token");
    if (token) {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (e) {
        localStorage.removeItem("shb_token");
      }
    }
    setLoading(false);
  }, [loadConfig]);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const loginWithToken = async (token) => {
    localStorage.setItem("shb_token", token);
    const { data } = await api.get("/auth/me");
    setUser(data);
    await loadConfig();
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("shb_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, config, loading, loginWithToken, logout, refreshConfig: loadConfig }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
